var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPreferencesIconsAccount = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "preferences_icons_Account")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preferences_icons_Account",
    transform: "translate(0.000000, 0.750000)",
    fill: "#63758D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2,2.1 C6.6,2.1 5.3,3.4 5.3,5 C5.3,6.6 6.6,8 8.2,8 C9.8,8 11.1,6.7 11.1,5.1 C11.1,3.5 9.8,2.1 8.2,2.1 Z M8.2,6.9 C7.2,6.9 6.4,6.1 6.4,5.1 C6.4,4.1 7.2,3.3 8.2,3.3 C9.2,3.3 10,4.1 10,5.1 C10,6.1 9.2,6.9 8.2,6.9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,0 C3.7,0 0,3.7 0,8.2 C0,12.7 3.7,16.4 8.2,16.4 C12.7,16.4 16.4,12.7 16.4,8.2 C16.4,3.7 12.7,0 8.2,0 Z M8.2,8.4 L8.2,8.4 C5.6,8.4 3.4,10.3 2.9,12.8 C0.4,10.1 0.5,5.8 3.2,3.2 C4.6,1.8 6.4,1.2 8.2,1.2 C10,1.2 11.8,1.9 13.2,3.3 C14.5,4.6 15.3,6.4 15.2,8.3 C15.2,10 14.6,11.7 13.4,13 C13,10.4 10.8,8.5 8.2,8.4 Z M4,13.4 C4.2,11.1 6.1,9.4 8.4,9.5 C9.5,9.6 10.5,10.1 11.3,10.9 C12,11.7 12.4,12.8 12.3,13.8 C9.8,15.7 6.4,15.7 4,13.8 C4,13.7 4,13.5 4,13.4 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreferencesIconsAccount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preferences_icons_Account.e0a4aa09.svg";
export { ForwardRef as ReactComponent };